<script setup>
import { ref } from "vue";
import { __ } from "@/app";
import axios from "axios";

const props = defineProps({
    question: {
        type: Object,
        default: null,
    },
});

const showForm = ref(false);
const reportText = ref('');
const reportStatus = ref(null);
const validationError = ref('');

const sendReport = async (text, exerciseId) => {
    try {
        validationError.value = '';
        if (!text.trim()) {
            validationError.value = __('Wiadomość jest wymagana');
            return;
        }
        reportStatus.value = await axios.post(route("contact.send"), {
            message: `Exercise: ${exerciseId}\n\n${text}`
        });        
    } catch(err) {
        if (err.response?.data?.errors?.message) {
            validationError.value = err.response.data.errors.message[0];
        } else {
            validationError.value = err.response?.data?.error || __('Wystąpił błąd podczas wysyłania wiadomości');
        }
    } finally {
        if (!validationError.value) {
            showForm.value = false;
            reportText.value = '';
        }
    }
}
// console.log(props.question.exercise_id)
// Report Issue: {{ props.question.exercise_id }}
</script>
<template>
    <div class="pb-3">
        <button
            v-if="!showForm" 
            class="btn btn-sm btn-warning"
            @click="showForm = true"
            style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;"
        >
            {{ __("Zgłosić problem") }}            
        </button>
        <div v-else>
            <h3>{{ __('Zgłosić problem') }}</h3>
            <textarea 
                v-model="reportText"
                v-bind:placeholder="__('Aby ulepszyć serwis, powiedz nam, co jest nie poprawnie, niewygodne lub warte naprawienia w następnej wersji. Dziękujemy!')" 
                required
                class="form-control mb-2"
                :class="{ 'is-invalid': validationError }"
                rows="4"
            ></textarea>
            <div v-if="validationError" class="invalid-feedback small mb-2">
                {{ validationError }}
            </div>
            <button 
                class="btn btn-sm btn-warning"
                @click="sendReport(reportText, props.question.exercise_id)"
                style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;"
            >
                {{ __("Wyślij") }}
            </button>
        </div>        
    </div>
</template>
